module.exports = __webpack_public_path__ + "static/media/NTNLogo.db9510b6.jpg";